module.exports = __webpack_public_path__ + "static/media/bio.4d7536be.jpg";